import React, { useEffect, useState } from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { transcriptApi } from '../../../../../api/transcriptApi';

/** Send the transcript to a mission site. Hidden when no missions are configured. */
export default function MissionCard({ sessionId, lang, notify }) {
  const [missions, setMissions] = useState([]);
  const [selected, setSelected] = useState('');
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    let cancelled = false;
    transcriptApi.listMissions()
      .then((res) => {
        if (cancelled) return;
        const items = Array.isArray(res?.missions) ? res.missions : [];
        setMissions(items);
        setSelected((current) => current || items[0]?.slug || '');
      })
      .catch(() => !cancelled && setMissions([]));
    return () => { cancelled = true; };
  }, []);

  if (missions.length === 0) return null;

  const send = async () => {
    setIsSending(true);
    try {
      const result = await transcriptApi.sendToMission(sessionId, selected, { lang });
      const sent = `Transcript sent to ${result.mission || selected} (${result.segment_count || 0} segments).`;
      notify({
        type: 'success',
        title: 'Sent to mission',
        message: result.link
          ? `${sent} DigWatch report: ${result.link}`
          : `${sent} No DigWatch report link was included because this session has not been published to DigWatch.`,
      });
    } catch (e) {
      notify({ type: 'error', title: 'Send to mission failed', message: e.message });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="session-detail-card">
      <h3>Send to mission</h3>
      <select
        aria-label="Mission"
        value={selected}
        onChange={(e) => setSelected(e.target.value)}
        className="session-side-select"
        disabled={isSending}
      >
        {missions.map((m) => <option key={m.slug} value={m.slug}>{m.slug}</option>)}
      </select>
      <div className="session-side-actions" style={{ marginTop: 8 }}>
        <button
          type="button"
          className="session-btn session-btn-secondary session-btn-full"
          onClick={send}
          disabled={isSending || !selected}
        >
          <ArrowTopRightOnSquareIcon />
          {isSending ? 'Sending...' : `Send to ${selected}`}
        </button>
      </div>
    </div>
  );
}
